import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import { Button, Card, Form, Input, notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
function UpdateOpeningHours() {
  const [form] = Form.useForm();
  // const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        Time: values.Time,
        Day: values.Day,
      };

      setIsLoading(true);
      let api = API.UPDATE_OPENING_HOURS + id;
      const postRequest: any = await PUT(api, obj);
      if (postRequest.status) {
        notification.success({
          message: "opening hours updated successfully!",
        });
        form.resetFields();
        fetchoneOpeningHours();
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchoneOpeningHours = async () => {
    try {
      setIsLoading(true);
      let api = API.FIND_ONE_OPENING_HOURS + id;
      const response: any = await GET(api, {});
      // setData(response?.data);
      form.setFieldsValue(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchoneOpeningHours();
  }, []);

  return (
    <div>
      <h1>Update Opening Hours Page</h1>
      <Card>
        <Form form={form} onFinish={UpdateHandler} layout="vertical">
          <Form.Item name="Time" label="Time" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="Day"
            label="Day"
            rules={[{ required: true, message: "Day is required" }]}
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateOpeningHours;
